<script>
export default {
    props: ['data'],
    name: "galleryMenu",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="gallery_menu">
        <div class="list">
            <div class="item" v-for="(item, index) in data" :key="index">
                <div class="top flex align_center">
                    <p class="name">{{ item.name }}</p>
                    <input type="text" v-model="item.search"/>
                    <img src="@/assets/images/icon_search.png" alt="" class="icon"/>
                </div>
                <div class="scroll_box">
                    <div class="list flex flex_column">
                        <div class="item" v-for="(_item, _index) in item.list" :key="_index">{{ _item }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.gallery_menu{
    width: 2.24rem;
    >.list{
        // position: sticky;
        // top: .9rem;
        // left: 0;
        >.item{
            border: 1px solid #000;
            margin-bottom: .5rem;
            &:last-child{
                margin-bottom: 0;
            }
            .top{
                padding: .2rem .15rem;
                border-bottom: 1px solid #000;
                .name{
                    font-size: .2rem;
                    flex: 1;
                }
                input{
                    width: .8rem;
                    height: .3rem;
                    border: 1px solid #000;
                    padding: 0 .1rem;
                    font-size: .16rem;
                }
                .icon{
                    width: .15rem;
                    height: .15rem;
                    margin-left: .1rem;
                    cursor: pointer;
                }
            }
            .scroll_box{
                max-height: 3rem;
                overflow: hidden;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: .08rem;
                }
                &::-webkit-scrollbar-track {
                    background: var(--body_bg);
                }
                &::-webkit-scrollbar-thumb {
                    background: #999;
                }
                .list{
                    padding: .1rem 0;
                    .item{
                        padding: .1rem .3rem;
                        font-size: .16rem;
                        color: #666;
                        cursor: pointer;
                        &:hover{
                            background: #f8f8f8;
                        }
                    }
                }
            }
        }
    }
}
</style>